import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Category } from '../../services/eleview/types/category';
import { Label } from '../../services/eleview/types/label';
import { OwnerByEnum } from '../../services/eleview/types/model';
import { EleViewBackFaceService } from '../../services/eleview/eleview-backface';

@Component({
	selector: 'common-label-select',
	templateUrl: './label-select.component.html',
	styleUrls: ['./label-select.component.scss']
})
export class LabelSelectComponent implements OnInit {
	@Input() selectedLabels: Label[];
	@Input() eleName: string;
	@Input() ownerBy: OwnerByEnum;
	@Input() owner: string;
	categories: Category[];
	@HostBinding('class.label-select') hostClass = true;
	constructor(private svr: EleViewBackFaceService) {}

	ngOnInit() {
		this.svr.fetchCategories({ EleName: this.eleName, OwnerBy: this.ownerBy, Owner: this.owner }).subscribe(v => {
			this.categories = v;
		});
	}
}
